import styled from 'styled-components'
import { HeaderText6 } from '../../components/HeaderText'

const FormSectionHeaderText = styled(HeaderText6)`
  margin: 1rem 0 0 0;
`

export { FormSectionHeaderText }
